module.exports = __webpack_public_path__ + "static/media/icon_shared-journal.0fd9824d.svg";